/**
 * Shopify 通用无限轮播（合并Logo + Image 轮播）
 * Tab切换自动重启轮播 | 无加速/无冲突/悬停正常,Image轮播≤3张静态显示
 */
document.addEventListener('DOMContentLoaded', function() {
  // 跳过Shopify编辑器模式
  if (Shopify.designMode) return;

  // ====================== 通用轮播初始化函数 ======================
  function initUniversalCarousel(sectionSelector, options = {}) {
    const allSections = document.querySelectorAll(sectionSelector);
    const defaultOpts = {
      trackClass: '',
      itemClass: '',
      getSpeed: (track) => -1.5,
      calcWidth: null,
      isStaticMode: (track) => false // 静态模式判断
    };
    const opts = { ...defaultOpts, ...options };

    allSections.forEach(section => {
      const allTracks = section.querySelectorAll(opts.trackClass);
      const sectionTimers = [];

      // ==============================================
      // 1. 一次性初始化（克隆、宽度、事件、move函数 只执行1次、判断静态还是动态滚动）
      // ==============================================
      function initTrack(track) {
        if (track.dataset.initialized === 'true') return;
        track.dataset.initialized = 'true';

        // 判断是否为静态模式（≤3张图片）
        const staticMode = opts.isStaticMode(track);
        if (staticMode) {
          track.dataset.noScroll = 'true'; // 标记禁止滚动
          // 静态模式：居中对齐 + 不设置固定宽度 + 不克隆、不滚动
          track.style.display = 'flex';
          track.style.justifyContent = 'center';
          track.style.width = '-webkit-fill-available';
          return;
        }

        // 动态模式：正常克隆内容
        if (!track.dataset.cloned) {
          track.innerHTML += track.innerHTML;
          track.dataset.cloned = true;
        }

        // 计算宽度
        if (typeof opts.calcWidth === 'function') opts.calcWidth(track);

        // 定义滚动核心函数
        const speed = opts.getSpeed(track);
        track._moveFunc = function() {
          if (track.offsetLeft < -track.offsetWidth / 2) track.style.left = '0';
          if (track.offsetLeft > 0) track.style.left = -track.offsetWidth / 2 + 'px';
          track.style.left = track.offsetLeft + speed + 'px';
        };

        // 悬停事件
        const handleMouseOver = () => clearInterval(track.timer);
        const handleMouseOut = () => restartTrackTimer(track);
        track.addEventListener('mouseover', handleMouseOver);
        track.addEventListener('mouseout', handleMouseOut);
      }

      // ==============================================
      // 2. 重启单轨道定时器
      // ==============================================
      function restartTrackTimer(track) {
        // 静态模式：不启动定时器
        if (track.dataset.noScroll === 'true') return;
        clearInterval(track.timer);
        track.timer = setInterval(track._moveFunc, 20);
        sectionTimers.push(track.timer);
      }

      // ==============================================
      // 3. 启动所有轨道（初始化 + 自动重启定时器）
      // ==============================================
      function startAll() {
        allTracks.forEach(track => {
          initTrack(track);
          restartTrackTimer(track);
        });
      }

      // ==============================================
      // 4. 停止所有轨道（仅清定时器，不破坏初始化）
      // ==============================================
      function stopAll() {
        sectionTimers.forEach(timer => clearInterval(timer));
        allTracks.forEach(track => {
          clearInterval(track.timer);
          track.timer = null;
        });
        sectionTimers.length = 0;
      }

      // ==============================================
      // 双重监听：视口滚动 + Tab显隐
      // ==============================================
      // 视口监听
      const intersectionObserver = new IntersectionObserver(entries => {
        // 【优化：兼容无Tab切换页面】
        // 规则：无tab-active类(无Tab) → 只要进入视口就启动；有tab-active类 → 必须满足激活状态才启动
        const shouldStart = entries[0].isIntersecting && 
          (!section.classList.contains('tab-active') || section.classList.contains('tab-active'));
        shouldStart ? startAll() : stopAll();
      }, { threshold: 0.1 });
      intersectionObserver.observe(section);

      // Tab类名监听
      const mutationObserver = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.attributeName === 'class') {
            // 【优化：兼容无Tab切换页面】无tab-active类的页面，不执行停止操作
            if (!section.classList.contains('tab-active')) return;
            section.classList.contains('tab-active') ? startAll() : stopAll();
          }
        });
      });
      mutationObserver.observe(section, { attributes: true });
    });
  }

  // ====================== 初始化 Logo 轮播 ======================
  initUniversalCarousel('[data-logo-carousel]', {
    trackClass: '.carousel-track',
    itemClass: '.logo-item',
    getSpeed: (track) => track.classList.contains('carousel-reverse') ? 1.5 : -1.5,
    calcWidth: (track) => {
      const logoItems = track.querySelectorAll('.logo-item');
      logoItems.length && (track.style.width = logoItems[0].offsetWidth * logoItems.length + 'px');
    }
  });

  // ====================== 初始化 Image 轮播（静态判断） ======================
  initUniversalCarousel('[data-image-carousel]', {
    trackClass: '.image-carousel-track',
    itemClass: '.image-item',
    getSpeed: () => -1.5,
    // 核心：判断图片数量 ≤3 则开启静态模式
    isStaticMode: (track) => {
      const imageItems = track.querySelectorAll('.image-item');

      // 768px为移动端断点，手机端直接关闭静态模式（恢复滚动）
      const isMobile = window.innerWidth <= 768;

      // 规则：非手机端 + 图片≤3张 → 静态居中；手机端一律滚动
      return !isMobile && imageItems.length <= 3;
    },
    calcWidth: (track) => {
      const imageItems = track.querySelectorAll('.image-item');
      if (imageItems.length) {
        const w = imageItems[0].offsetWidth;
        const m = parseFloat(getComputedStyle(imageItems[0]).marginRight) || 0;
        track.style.width = (w + m) * imageItems.length + 'px';
      }
    }
  });
});